// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"64a7d39e","64":"4d37e7dc","139":"ab0e299e","244":"07aeaf35","375":"fcafae8a","431":"5ba3a2f5","486":"01c62792","540":"64595298","639":"bbb6a610","655":"a4ab8c68","726":"63e59fed","771":"de99b150","974":"60b8e673"}[chunkId] + ".chunk.js";
};